import { render, staticRenderFns } from "./CmgAccountModalJoinRewards.vue?vue&type=template&id=0434ad54&scoped=true&lang=pug"
import script from "./cmg-account-modal-join-rewards.ts?vue&type=script&lang=ts&external"
export * from "./cmg-account-modal-join-rewards.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAccountModalJoinRewards.vue?vue&type=style&index=0&id=0434ad54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0434ad54",
  null
  
)

export default component.exports